import { ErrorDeApi } from '@/shared/api/problema';

export function mensajeDe(causa: unknown, porOmision: string): string {
  if (!(causa instanceof ErrorDeApi)) {
    return porOmision;
  }
  const primero = causa.erroresDeCampo[0];
  return primero ? primero.mensaje : causa.message;
}
